<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Account Settings
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Lien social
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-transports"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Transports
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="row">
            <div class="col-12 mb-40">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-10">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Type client
                      </label>
                      <input
                        type="text"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="type.name"
                      />
                    </div>
                  </div>
                  
                  <div class="col-md-2">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <button
                        class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                        type="submit"
                        style="margin-top: 2rem;"
                      >
                        Save
                      </button>
                      <!-- <button
                        type="button"
                        class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                    >
                        <i
                        class="flaticon-delete lh-1 me-1 position-relative top-2"
                        ></i>
                        <span class="position-relative">Cancel</span>
                    </button> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div class="col-12 mt-20">
              <h5 class="fs-16 fw-semibold mb-20">Liste des status</h5>
              <EasyDataTable
                :headers="headers"
                :items="types"
                buttons-pagination
              >

                <!-- Custom "actions" column -->
                <template #item-actions="{ id }">
                    <div class="dropdown">
                    <button
                        class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                        <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);"
                        >
                            <i
                            class="flaticon-pen lh-1 me-8 position-relative top-1"
                            ></i>
                            Modifier
                        </a>
                        </li>
                        <li>
                        <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);"
                            @click="deleteType(id)"
                        >
                            <i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                            ></i>
                            Supprimer
                        </a>
                        </li>
                    </ul>
                    </div>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();
    const types = ref([]);

    const headers = [
      { text: "Type", value: "name" },
      { text: "Clients", value: "NbClient" },
      { text: "Actions", value: "actions" },
    ];

    const type = reactive({
      name: "",
    });

    onMounted(async () => {
      fetchTypes();
    });

    async function fetchTypes() {
      try {
        const response = await api.get("/api/auth/typeClient_list");
        if (response && response.data) {
          // handle the fetched cities data
          // console.log("Fetched cities:", response.data);
          types.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    // Submit form
    async function submitForm() {
      try {
        const formData = new FormData();
        formData.append("name", type.name);
        const response = await api.post("/api/auth/typeClient_add", formData);

        if (response.data.message == "success") {
          fetchTypes(); // Refresh the status list
          // Clear the form
          type.name = "";
          showToast("Settings saved successfully!", "success");
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while saving settings.", "error");
      }
    }

    async function deleteType(id) {
      if (confirm("Are you sure you want to delete this city?")) {
        try {
        //   const response = await api.post(`/api/auth/destroyCity/${id}`);
        //   if (response.data.message === "success") {
        //     // Remove the city from the local list
        //     fetchTypes();
        //     showToast("City deleted successfully!", "success");
        //   } else {
        //     showToast("Error deleting city: " + response.data.message, "error");
        //   }
        } catch (error) {
          console.error("Error deleting city:", error);
          showToast("An error occurred while deleting the city.", "error");
        }
      }
    }

    return {
      types,
      headers,
      submitForm,
      type,
      deleteType
    };
  },
});
</script>